import { refreshAccessToken } from "./apiClient";
import { API_URL } from "./constant"


// helper for sending the produt pricing list request
async function attemptListProductPricing(page,page_size,token,searchTerm) {
    const params = new URLSearchParams({
        page,
        page_size: page_size
    })

    if (searchTerm) params.append('search',searchTerm)
    
    const response = await fetch(`${API_URL}/product_price/?${params.toString()}`,{
        method:'GET',
        headers:{
            'Authorization': `Bearer ${token}`,
        }
    })

    const responseData = await response.json();

    if (!response.ok){
        const err = new Error("Failed to fetch the Product Price List");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// main product price list function
export async function listProductPrice(page,page_size,searchTerm) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attemptListProductPricing(page,page_size,accessToken,searchTerm);
    }catch(error){
        if(error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attemptListProductPricing(page,page_size,newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while getting product price list",error?.data || error.message);
        throw error;
    }
}

// helper for sending adding the product price list
async function attempAddProductPrice(data,token) {
    const response = await fetch(`${API_URL}/product_price/`,{
        method:'POST',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data)
    })

    const responseData = await response.json();

    if (!response.ok){
        const err = new Error("Failed to add Product Price");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}
// main function to add product price
export async function addProductPrice(data) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attempAddProductPrice(data,accessToken);
    }catch(error){
        if(error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attempAddProductPrice(data,newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",ReferenceError.message);
                throw refreshError;
            }
        }
    }
    console.log("Error while creating the product",error?.data || error.message);
    throw error;
}
// helper for updating the product price
async function attempUpdateProductPrice(data,token) {
    const productPriceData = {};
    if(data.product) productPriceData.product = data.product;
    if (data.price) productPriceData.price = data.price;
    if (data.fromDate) productPriceData.from_date = data.fromDate;

    const response = await fetch(`${API_URL}/product_price/${data.id}/`,{
        method:'PATCH',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(productPriceData)
    })

    const responseData = await response.json();

    if(!response.ok){
        const err = new Error("Updating Product Price failed")
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}
// main function to update the product
export async function updateProductPrice(data) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attempUpdateProductPrice(data,accessToken);
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attempUpdateProductPrice(data,newAccessToken);
            }catch(refreshError){
                console.log("Token refresh Failed", refreshError.message)
                throw refreshError;
            }
        }
        console.log("Error while updating the Product Prcie data", error?.data || error.message)
        throw error;
    }
}